const state = {
	ticketDashboardTabName: "dashboard",
	ticketsDashboardSummary: {
		total: 0,
		open: 0,
		closed: 0,
		average_rt: "0",
		within_sla: 0,
		violation: 0,
		within_sla_percentage: 0,
		violation_percentage: 0,
	},
	selectedLocation: null,
	reportView: "wtd",
	fromDate: "",
	toDate: "",
	reportType: "location",
	reportTypeValue: [],
	outletList: [],
	categoryList: [],
	ticketData: [],
  isDashboardLoading: false,
  ticketLocationDashboardBasics: 'region',
  ticketDashboardCountries: [],
  ticketDashboardRegions: [],
  ticketDashboardSubregions: [],
  ticketDashboardOutlets: [],
};

const mutations = {
  updateTicketsDashboardSummary: (state, payload) => {
    state.ticketsDashboardSummary = payload;
  },
  updateTicketDashboardTabName: (state, payload) => {
    state.ticketDashboardTabName = payload;
  },
  updateSelectedLocation: (state, payload) => {
    state.selectedLocation = payload;
  },
  updateReportView: (state, payload) => {
    state.reportView = payload;
  },
  updateFromDate: (state, payload) => {
    state.fromDate = payload;
  },
  updateToDate: (state, payload) => {
    state.toDate = payload;
  },
  updateReportType: (state, payload) => {
    state.reportType = payload;
  },
  updateReportTypeValue: (state, payload) => {
    state.reportTypeValue = payload;
  },
  updateOutletList: (state, payload) => {
    state.outletList = payload;
  },
  updateCategoryList: (state, payload) => {
    state.categoryList = payload;
  },
  updateTicketData: (state, payload) => {
    state.ticketData = payload;
  },
  updateIsDashboardLoading: (state, payload) => {
    state.isDashboardLoading = payload;
  },
  updateTicketLocationDashboardBasics: (state, payload) => {
    state.ticketLocationDashboardBasics = payload;
  },
  updateTicketDashboardCountries: (state, payload) => {
    state.ticketDashboardCountries = payload;
  },
  updateTicketDashboardRegions: (state, payload) => {
    state.ticketDashboardRegions = payload;
  },
  updateTicketDashboardSubregions: (state, payload) => {
    state.ticketDashboardSubregions = payload;
  },
  updateTicketDashboardOutlets: (state, payload) => {
    state.ticketDashboardOutlets = payload;
  },
};

export default {
  state,
  mutations,
  namespaced: true
};